<template>
  <transition name="el-fade-in-linear">
    <div class="sn-bs-dialog" v-if="visibility">
      <div class="sn-bs-dialog__mask"></div>
      <div class="sn-bs-dialog__inner">
        <button class="sn-bs-dialog__close-btn" @click="handleClose"></button>
        <header class="sn-bs-dialog__header">
          <slot name="header">
            <h2 class="sn-bs-dialog__header-title">{{ title }}</h2>
          </slot>
        </header>
        <section class="sn-bs-dialog__body">
          <template v-if="showEmpty">
            <bs-empty />
          </template>
          <template v-else>
            <bs-scrollbar>
              <slot></slot>
            </bs-scrollbar>
          </template>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import BsScrollbar from "@/components/bs/BsScrollbar";
import BsEmpty from "@/components/bs/BsBoxPanel/Empty";
export default {
  name: "BsDialog",
  model: {
    prop: "visibility",
    event: "on-closed",
  },
  props: {
    visibility: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    modal: {
      type: Boolean,
      default: true,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit("on-closed", false);
    },
  },
  watch: {
    visibility(val) {
      if (val) {
        this.$nextTick(() => {
          document.body.appendChild(this.$el);
        });
      }
    },
  },
  components: {
    BsScrollbar,
    BsEmpty,
  },
};
</script>

<style scoped lang="scss">
@include bs(dialog) {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  @include utils-full-win();

  @include e(mask) {
    @include utils-full-box();
    background-color: rgba($--color-black, 0.5);
  }

  @include e(inner) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 769px;
    height: 581px;
    background: url("~@/assets/images/bs/bg-dialog.png") no-repeat;
    box-sizing: border-box;
    padding: 50px 16px 38px 30px;
  }
  @include e(close-btn) {
    position: absolute;
    right: 6px;
    top: -5px;
    cursor: pointer;
    border: 0 none;
    outline: none;
    padding: 0;
    width: 73px;
    height: 30px;
    background: url("~@/assets/images/bs/bg-close.png") no-repeat transparent;
  }

  @include e(header) {
    height: 40px;
    line-height: 40px;
  }
  @include e(header-title) {
    font-size: 24px;
    color: #43e58e;
    line-height: 1.5;
    font-weight: bold;
    text-align: center;
  }

  @include e(body) {
    width: 100%;
    height: calc(100% - 40px);
    font-size: $--font-size-base;
    color: #3ac279;
    line-height: 1.5;
  }
}
</style>
